
import AttendResultForm from './AttendResultForm';

export default AttendResultForm;
